module.exports = __webpack_public_path__ + "media/images/icon/icon-select-3ad4bc3d4c60772740ee20bb4033c5c3.svg";